/**
 * Generated by orval v8.23.0 🍺
 * Do not edit manually.
 * Arbi API
 * OpenAPI spec version: 1.0.0
 */

export type ReplyRequestType = typeof ReplyRequestType[keyof typeof ReplyRequestType];


export const ReplyRequestType = {
  reply: 'reply',
  reply_all: 'reply_all',
  new_thread: 'new_thread',
} as const;
